import React from 'react';
import City from '../City';
type Props = {};

const CityContainer = (props: Props) => {
  return <City />;
};

export default CityContainer;
